import { Components, Theme } from '@mui/material/styles';

export const chatMessageTheme: Components<Theme>['MuiPaper'] = {
  // styleOverrides: {},
  // variants: [],
};
